import { createAsyncThunk } from '@reduxjs/toolkit';
import { secure_instance } from '../../api/axios/axios-config';
import { instance } from '../../api/axios/axios-config';
import { handleApiError } from '../../api/axios/interceptors';

export const GetApps = createAsyncThunk(
    'integration/getApps',
    async (_, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await instance.request({
                url: `/v1/apps?offset=0&limit=100&category=Ats`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);


export const ConnectApps = createAsyncThunk(
    'integration/connectApps',
    async (apiKey, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await secure_instance.request({
                url: `/v1/connections/api_key?app_id=workable`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
                data: { api_key: apiKey }
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);

export const UpdateAPiKey = createAsyncThunk(
    'integration/UpdateAPiKey',
    async (apiKey, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await secure_instance.request({
                url: `/v1/connections/api_key?app_id=workable`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
                data: { api_key: apiKey }
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message || error);

        }
    }
);

export const GetAllStages = createAsyncThunk(
    'integration/getAllStages',
    async (_, { rejectWithValue, getState, dispatch }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;

            // First call the sync API
            const syncRequest = await secure_instance.request({
                url: `/v1/job_interview_stages/sync?mode=sync`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            // Check if sync was successful
            if (syncRequest?.status >= 200 && syncRequest?.status < 300) {
                // Call GetStages API on sync success
                const getStagesRequest = await secure_instance.request({
                    url: `/v1/job_interview_stages/`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                return getStagesRequest?.data;
            } else {
                // If sync failed, return the sync response
                return syncRequest?.data;
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const DeleteConnection = createAsyncThunk(
    'integration/deleteConnection',
    async (_, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await secure_instance.request({
                url: `/v1/connections/`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);

export const GetJobs = createAsyncThunk(
    'integration/getJobs',
    async (params = {}, { rejectWithValue, getState, dispatch }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;

            // First call the sync API
            const syncRequest = await secure_instance.request({
                url: `/v1/jobs/sync?mode=sync`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            // Check if sync was successful
            if (syncRequest?.status >= 200 && syncRequest?.status < 300) {
                // Call GetAllJobs API on sync success
                const getAllJobsRequest = await secure_instance.request({
                    url: `/v1/jobs/`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        ...params,
                        status: "published",
                    },
                });

                return getAllJobsRequest?.data;
            } else {
                // If sync failed, return the sync response
                return syncRequest?.data;
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const GetStages = createAsyncThunk(
    'integration/getStages',
    async (_, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await secure_instance.request({
                url: `/v1/job_interview_stages/`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);

export const GetAllJobs = createAsyncThunk(
    'integration/getAllJobs',
    async (_, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await secure_instance.request({
                url: `/v1/jobs/`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);
export const IntegrateSettings = createAsyncThunk(
    "integration/integrateSettings",
    async (data, { rejectWithValue }) => {
        try {
            if (!data.auth_token) {
                return rejectWithValue("No access token provided.");
            }
            const response = await secure_instance.request({
                url: "/v1/integration_settings/",
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${data.auth_token}`,
                    "Content-Type": "application/json",
                },
                data: {
                    app_id: data.app_id,
                    assessment_settings: data.assessment_settings,
                    job_mappings: data.job_mappings,
                },
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);


export const GetSettings = createAsyncThunk(
    'integration/getSettings',
    async ({ app_id }, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;
            const request = await secure_instance.request({
                url: `/v1/integration_settings/${app_id}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);

        }
    }
);

export const ConnectedApps = createAsyncThunk(
    'integration/getConnection',
    async ({ id }, { rejectWithValue, getState }) => {
        try {
            const accessToken = getState().authReducer?.data?.access_token;

            const request = await secure_instance.request({
                url: `/v1/connections/${id}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return request?.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);




